@if (isDocumentsLoading()) {
  <div class="absolute flex w-full items-center justify-center" data-qa="tourist-docs-loader">
    <mat-progress-bar mode="indeterminate" />
  </div>
}
<div class="px-6">
  @if (!isReservationNew()) {
    <div class="pt-4" data-qa="tourist-docs-upload-warning-message">
      <app-message-box type="warn" [message]="uploadAllowedStatusMessage" />
    </div>
  }
  <div class="my-2 flex flex-col gap-2 h-[250px] overflow-y-auto">
    @for (document of documents(); track document.fileId) {
      <div
        class="flex flex-row gap-2 border-1 border-c-line-light p-3 items-center"
        data-qa="tourist-doc-item"
        [attr.data-qa-file-id]="document.fileId"
      >
        <!-- `min-w-0` lets the title shrink below its text; without it an overlong one pushes View and Delete out of the row -->
        <div class="flex-1 min-w-0 truncate" data-qa="tourist-doc-title" [attr.title]="document.title">
          {{ document.title }}
        </div>
        <div class="flex shrink-0 items-center justify-center gap-2">
          <button
            type="button"
            color="primary"
            mat-stroked-button
            class="border-kz-primary! rounded-none! text-xs! tracking-normal!"
            loadingStyleClass="scale-40 left-0!"
            data-qa="tourist-doc-view-button"
            [disabled]="isDownloading()"
            [loading]="isDownloading() && downloadingFileId() === document.fileId"
            (click)="onDownloadDocument(document)"
          >
            {{ 'View' | translate }}
          </button>
          <button
            type="button"
            class="kz-icon-button"
            data-qa="tourist-doc-delete-button"
            (click)="onDeleteDocument(document)"
          >
            @if (isDeleting() && deletingFileId() === document.fileId) {
              <mat-progress-spinner mode="indeterminate" [diameter]="28" />
            } @else {
              <mat-icon class="material-icons-outlined" fontIcon="delete" />
            }
          </button>
        </div>
      </div>
    }
  </div>
  <form class="py-2 border-t-1 border-c-line-light" [formGroup]="formGroup" [ngxsForm]="ngxsForm">
    <div class="flex flex-row gap-2">
      <div class="w-full flex flex-col gap-2 items-top justify-end">
        <label for="title" class="mt-2 required">{{ 'Document Title' | translate }}</label>
        <input
          id="title"
          type="text"
          wrapperStyleClass="h-8!"
          kzInput
          placeholder="Title"
          formControlName="title"
          data-qa="tourist-docs-title-input"
          errorQa="tourist-docs-title-error"
          [errorMessage]="isSubmitted() ? formGroup.controls.title.errors : null"
        />
      </div>
      <div class="w-full flex flex-col gap-2 items-top justify-end">
        <label for="file" class="mt-2 required">{{ 'Choose File' | translate }}</label>
        <input
          #fileInputRef
          type="file"
          id="file"
          wrapperStyleClass="h-8!"
          kzInput
          class="mt-3"
          placeholder="Choose File"
          data-qa="tourist-docs-file-input"
          errorQa="tourist-docs-file-error"
          [errorMessage]="isSubmitted() ? formGroup.controls.file.errors : null"
          [accept]="acceptedFilesTypes"
          [attr.disabled]="isUploadAllowed() ? null : ''"
          (change)="onFileSelected()"
        />
      </div>
    </div>

    @if (uploadRefusalMessage(); as uploadRefusalMessage) {
      <div class="pt-4" data-qa="tourist-docs-upload-error-message">
        <app-message-box type="error" [message]="uploadRefusalMessage" />
      </div>
    }

    <ng-template #modalFooterTemplateRef>
      <div class="py-2 flex px-2 items-center justify-end gap-8">
        <button
          class="link-btn reverse-primary uppercase!"
          type="button"
          data-qa="tourist-docs-close-button"
          (click)="onDynamicModalClose?.()"
        >
          {{ 'Close' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          class="h-9! w-30"
          type="button"
          data-qa="tourist-docs-upload-button"
          [loading]="isUploading()"
          [disabled]="isUploadDisabled()"
          (click)="onSubmit()"
        >
          {{ 'Upload' | translate }}
        </button>
      </div>
    </ng-template>
  </form>
</div>
